<template>
  <div class="col-12 col-md-6 px-md-0" :class="classSelector">
    <h4 id="versel1">{{ labelSelector }}</h4>
    <div class="pt-2 pb-4">
      <div class="row w-100 mx-0">
        <b-form-select
          class="custom-select form-control-lg multiple mb-3"
          v-model="sectorSeleccionado"
          @change="cambiarSectorEconomico"
        >
          <option disabled value="null">Sector Económico</option>
          <option
            :value="sector"
            v-for="sector in obtenerSectorEconomico"
            :key="sector.index"
          >
            {{ sector }}
          </option>
          <option value="TODOS">Todos</option>
        </b-form-select>
      </div>

      <div class="row w-100 mx-0">
        <b-form-select
          v-model="nivelSeleccionado"
          class="custom-select form-control-lg multiple mb-3"
          @change="cambiarNivel"
        >
          <option disabled value="null">Nivel Formativo</option>
          <option
            :value="nivel"
            v-for="nivel in obtenerNivelFormativo"
            :key="nivel.index"
          >
            {{ nivel }}
          </option>
          <option value="TODOS">Todos</option>
        </b-form-select>
      </div>

      <div class="row w-100 mx-0">
        <b-form-select
          v-model="carreraSeleccionada"
          class="custom-select form-control-lg multiple"
          @change="seleccionarCarrera"
        >
          <option disabled value="null">Carrera Genérica</option>
          <option
            :value="carrera"
            v-for="carrera in obtenerCarreraGenerica"
            :key="carrera.index"
          >
            {{ carrera }}
          </option>
        </b-form-select>
      </div>
    </div>
  </div>
</template>

<script>
import ApiComparadorTP from "@/services/ApiComparadorTP";

export default {
  name: "SelectorCarrera",
  props: {
    labelSelector: { type: String },
    classSelector: { type: String }
  },
  data() {
    return {
      listadoCarreras: [],
      sectorSeleccionado: null,
      nivelSeleccionado: null,
      carreraSeleccionada: null
    };
  },
  async created() {
    this.listadoCarreras = await this.cargarCarreras();
  },
  computed: {
    obtenerSectorEconomico() {
      if (this.listadoCarreras.length >= 1) {
        let sectores = this.listadoCarreras.map(s => s.sectorEconomico);
        sectores = [...new Set(sectores)];
        sectores.sort((a, b) => a.localeCompare(b));
        return sectores;
      } else {
        return [];
      }
    },
    obtenerNivelFormativo() {
      if (this.listadoCarreras.length >= 1) {
        let niveles = this.listadoCarreras;
        niveles = this.filtrarSector(niveles);
        niveles = niveles.map(n => n.nivelFormativo);
        niveles = [...new Set(niveles)];
        niveles.sort((a, b) => b.localeCompare(a));
        return niveles;
      } else {
        return [];
      }
    },
    obtenerCarreraGenerica() {
      if (this.listadoCarreras.length >= 1) {
        let carreras = this.listadoCarreras;
        carreras = this.filtrarSector(carreras);
        carreras = this.filtrarNivel(carreras);
        carreras = carreras.map(n => n.carreraGenerica);
        carreras = [...new Set(carreras)];
        carreras.sort((a, b) => a.localeCompare(b));
        return carreras;
      } else {
        return [];
      }
    }
  },
  methods: {
    async cargarCarreras() {
      let carreras = await ApiComparadorTP.getListadoCarrerasTP();
      return carreras;
    },
    seleccionarCarrera(val) {
      this.$emit("seleccionarCarrera", val);
    },
    cambiarSectorEconomico() {
      this.nivelSeleccionado = null;
      this.carreraSeleccionada = null;
      this.reiniciarSeleccion();
    },
    cambiarNivel() {
      this.carreraSeleccionada = null;
      this.reiniciarSeleccion();
    },
    reiniciarSeleccion() {
      this.$emit("reiniciarSeleccion");
    },
    filtrarSector(arreglo) {
      if (
        this.sectorSeleccionado !== null &&
        this.sectorSeleccionado !== "TODOS"
      ) {
        return arreglo.filter(
          n => n.sectorEconomico === this.sectorSeleccionado
        );
      } else {
        return arreglo;
      }
    },
    filtrarNivel(arreglo) {
      if (
        this.nivelSeleccionado !== null &&
        this.nivelSeleccionado !== "TODOS"
      ) {
        return arreglo.filter(n => n.nivelFormativo === this.nivelSeleccionado);
      } else {
        return arreglo;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/comparadorITP/SelectorCarrera.vue